import styled from 'styled-components';

export const ReviewTitle = styled.h2`
  color: #000000;
  font-family: "Jost", sans-serif;
  font-size:20px;
  font-weight: 600; 
  line-height: 30px;
  margin-bottom: 15px;
  margin-top: 15px;
  @media screen and (max-width:991px) {
    font-size:18px;
    line-height: 28px;
  }

  @media screen and (max-width:575px) {
    font-size:16px;
    line-height: 26px;
  }
`; 

export const ReviewStrong = styled.strong`
     color:#FE484F;
     font-weight: 600;
`;

export const ReviewSpan = styled.span`
  color:#01606F;
`;
 
export const ReviewBox = styled.div`
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-radius: 20px;
  padding:20px;
  margin-bottom: 20px;
  box-shadow: 0px 5px 30px #0000001A;
  margin-bottom: 20px;
  width:100%;
  &:last-child{
    margin-bottom: 20px;
  }

  @media screen and (max-width: 767px){
    border-radius: 10px;
    margin-bottom: 15px;
    padding:10px;
  }

  &:last-child{
    margin-bottom: 0px;
  }
  
  .rating-star{

    img{
      width: 100%;
      height: 100%;
      display: block;
      min-width: 24px;
      min-height: 24px;
      object-fit: contain;

      @media screen and (max-width: 767px){
        min-width: 16px;
        min-height: 16px;
      }
    }

  }

  .RatingReview{
    display:  none;
  }
button.btn-outline-success-blue.btn.btn-primary {
      @media screen and (max-width: 767px){
        margin-bottom: 10px;
  }
}

`;

export const ReviewContent = styled.p`
  color: #000000;
  font-family: "Jost", sans-serif;
  font-size:14px;
  font-weight: 400;
  line-height:21px;
  margin-bottom: 10px;
  margin-top: 20px;

`;

export const ReviewRole = styled.span`
  color: #33A7AE;
  font-family: "Jost", sans-serif;
  font-size:16px;
  font-weight: bold;
  line-height:21px;
  margin-bottom: 0px;
`; 

export const ReviewDonor = styled.span`
  color: #333333;
  font-family: "Jost", sans-serif;
  font-size:16px;
  font-weight: bold;
  line-height:21px;
  margin-bottom: 0px;
  display: inline-flex;
  margin-bottom: 10px;

  &:last-child{
    margin-left: 5px;
  }
`; 

export const ClientReview = styled.div`
 
`; 

export const ReviewHelp = styled.div`
  border-top:1px solid #0000001A;
  display: flex;
  justify-content: space-between;
  margin-top:20px;
  margin-bottom: 40px;
  padding-top: 20px;
     @media screen and (max-width:991px){
           flex-wrap: wrap;
           gap: 20px;
     }
`;

export const ReviewHelpLeft = styled.div`
    
`;
export const ReviewHelpRight = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const HelpTitle = styled.p`
  color: #333333;
  font-family: "Jost", sans-serif;
  font-size:16px;
  font-weight: 400;
  line-height: 21px;
  margin-bottom: 0px;
`;

export const ReviewLike = styled.div`
  display: flex;
  gap:5px;
  align-items: center;

`;

export const ReviewLikeOrange = styled.span`
      
`;

export const ReviewLikeBlack = styled.span`
  svg{
    transform: rotate(180deg);
      path{
      stroke: #333;
    }
  }
`;

export const ShareSocial = styled.h3`
  color: #333333;
  font-family: "Jost", sans-serif;
  font-size:16px;
  font-weight: bold;
  line-height: 21px;
  margin-bottom:0px;
`;

export const ShareSocialList = styled.ul`
padding: 0;
margin: 0;
list-style: none;
display: flex;
gap: 10px;
`;

export const ShareSocialItem = styled.li`
  .social-btn{
    padding: 0;
    border: none;
    width: 36px;
    height: 36px;
    background: #F7931E 0% 0% no-repeat padding-box;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &:nth-child(2){
    .social-btn{
    background: #4267B2 0% 0% no-repeat padding-box;
    border-radius: 10px;
    }
  }
  &:nth-child(3){
    .social-btn{
      background: #000000 0% 0% no-repeat padding-box;
      border-radius: 10px;
    }
  }
`;

export const ReviewNonprofit = styled.div`
  .btn-outline-success-blue{
    padding: 12px 31px;
  }
`;

export const ReviewDate = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DateCol = styled.div`
  color: #33A7AE;
  font-family: "Jost", sans-serif;
  font-size:16px;
  font-weight:500;
  line-height: 21px;
  margin-bottom: 0px;

  @media screen and (max-width: 767px){
    font-size:14px;
    line-height: 18px;
  }

`;

export const ReviewImage = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  column-gap: 26px;
  margin: 20px 0px;
`;

export const ReviewImageBox = styled.div`
    max-width: 120px;
    max-height: 120px;
    overflow: hidden;
    border-radius: 10px;

    img{
        width: 100%;
        height: 100%;
        display: block;
    }
`;

export const NonBtn = styled.div`
    display: flex;
    gap: 16px;
      @media screen and (max-width: 767px){
            flex-wrap: wrap;
      }
`;
